import {
    Column,
    Entity,
    Index,
    JoinColumn,
    ManyToOne,
    OneToMany, OneToOne,
    PrimaryGeneratedColumn, VersionColumn,
} from "typeorm";
import { BetaReaderProject } from "./BetaReaderProject";
import { WriterProfile } from "./WriterProfile";
import { ProjectProfileSelection } from "./ProjectProfileSelection";
import {Delta} from "quill/core";
import {ProjectProfileGroup} from "./ProjectProfileGroup";

@Index("project_pkey", ["id"], { unique: true })
@Index("project_uuid", ["uuid"], { unique: true })
@Entity("project")
export class Project {
  @PrimaryGeneratedColumn({ type: "bigint", name: "id" })
  id!: number;

  @Column("text", { name: "summary", nullable: true })
  summary!: string | null;

  @Column("text", { name: "last_info", nullable: true})
  lastInfo!: string;

  @Column("boolean", {
    name: "looking_for_beta_readers",
    default: () => "false",
  })
  lookingForBetaReaders!: boolean;

  @Column("text", { name: "title", nullable: false })
  title!: string;

  @Column("text", { name: "pen_name_given_name", nullable: true })
  penNameGivenName: string | null;

  @Column("text", { name: "pen_name_surname", nullable: true })
  penNameSurname: string | null;

  @Column("boolean", { name: "uses_pen_name", nullable: false, default: () => "false" })
  usesPenName!: boolean;

  @Column("boolean", { name: "has_content", nullable: false, default: () => "false" })
  hasContent!: boolean;

  @Column("uuid", { name: "uuid" })
  uuid!: string;

  @Column("text", { name: "schema_code", nullable: false, default: () => "FICTION_SERIES" })
  schemaCode!: string;

  @OneToMany(
    (type) => BetaReaderProject,
    (betaReaderProject) => betaReaderProject.project
  )
  betaReaderProjects!: BetaReaderProject[];

  @ManyToOne((type) => WriterProfile, (writerProfile) => writerProfile.projects)
  @JoinColumn([{ name: "writer_profile_id", referencedColumnName: "id" }])
  writerProfile!: WriterProfile;

  @OneToOne(
    (type) => ProjectProfileGroup
  )
  @JoinColumn([{ name: "profile_group_id", referencedColumnName: "id" }])
  profileGroup!: ProjectProfileGroup;
}
